import { useEffect, useState } from "react";
import InputField from "../../ResetContext/components/InputField";
import { useUsersContext } from "../../../../../context/usersContext";
import Select, { components } from "react-select";
import MultipleWebpages from "./MultipleWebpages";

const SingleWebpage = ({
  urlType,
  isSharedKnowledge = false,
  url,
  setUrl,
  setSelectedOption,
  selectedOption,
  scrapedData,
  loading,
  scrapeWebsite,
  crawlerModal,
  selected,
  handleSelect,
  submitHandler,
}) => {
  const { fetchAgentsArray } = useUsersContext();
  const [options, setOptions] = useState([]);
  const [loader, setLoading] = useState(false);

  // Basic URL validation (same rule used for scraping a website)
  const urlRegex = /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/;
  const isValidUrl = urlRegex.test((url || "").trim());
  const showUrlError = url !== "" && !isValidUrl;

  const agentOptions = async () => {
    setLoading(true);
    const agents = await fetchAgentsArray();
    const optins = agents
      ?.filter(
        (item) => !(item.readonly && item.assist_type !== "account-only")
      )
      .filter((item) => item.status === true)
      ?.map((item) => ({
        label: item?.assistant_name,
        value: item?.assistant_id,
      }));
    setOptions(optins || []);
    setLoading(false);
  };

  useEffect(() => {
    agentOptions();
  }, []);

  const LoadingMessage = (props) => {
    return (
      <components.LoadingMessage {...props}>
        <div className="flex items-center gap-2 p-2">
          <span className="loader w-4 h-4 border-2 border-gray-300 border-t-blue-500 rounded-full animate-spin"></span>
          <span>Loading options...</span>
        </div>
      </components.LoadingMessage>
    );
  };

  if (!crawlerModal || !urlType === "webpage")
    return (
      <div className="">
        <InputField
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          disabled={false}
          placeholder={"Enter a URL"}
          classNames={"!p-4 focus:!border-[#d9d9d9]"}
        />
        {showUrlError && (
          <p className="text-sm text-[#ec221f] mt-2">
            Please enter a valid URL (e.g. https://example.com)
          </p>
        )}
        {/* Shared knowledge uploads to the profile, so no agent is selected. */}
        {!isSharedKnowledge && (
          <Select
            closeMenuOnSelect={true}
            isMulti
            options={options}
            onChange={setSelectedOption}
            isLoading={loader}
            components={{ LoadingMessage }}
            className="mt-4"
            styles={{
              input: (provided) => ({
                ...provided,
                padding: "13px",
                fontSize: "16px",
                color: "#000",
              }),
            }}
          />
        )}
        <button
          className={`w-full mt-7 text-lg font-medium rounded-[3px] py-4 ${
            !url && selectedOption.length !== 0
              ? "text-[#757575] bg-[#f5f5f5] border !border-[#d9d9d9] "
              : "bg-black text-white border-black border"
          }`}
          disabled={
            (!isSharedKnowledge && selectedOption.length === 0) ||
            loading ||
            url === "" ||
            !isValidUrl
          }
          onClick={urlType === "single" ? submitHandler : scrapeWebsite}
        >
          {loading ? "Wait..." : "Next"}
        </button>
      </div>
    );
  else
    return (
      <MultipleWebpages
        scrapedData={scrapedData}
        handleSelect={handleSelect}
        selected={selected}
        loading={loading}
        url={url}
        submitHandler={submitHandler}
      />
    );
};

export default SingleWebpage;
